// All the breakpoints
export const breakpoints = {
  // Min-based breakpoints
  SM: 768,
  SMALL: 768,
  MINITABLET: 768,

  MD: 1024,
  MEDIUM: 1024,
  TABLET: 1024,

  XLARGE: 1440,
  XL: 1440,
  DESKTOP: 1440,

  // Max-based breakpoints
  WIDTH_MAX_MOBILE: 767,
  WIDTH_MAX_MINITABLET: 1023,
  WIDTH_MAX_TABLET: 1439,
}

export function screenwidth() {
  return window.screen.width
}

export function bp(breakpoint, callback) {
  if (breakpoint === breakpoints.WIDTH_MIN_TABLET) {
    callback()
  }
  if (breakpoint === breakpoints.WIDTH_MIN_MINITABLET) {
    callback()
  }
  if (breakpoint === breakpoints.WIDTH_MIN_TABLET) {
    callback()
  }
}
